import React from 'react'
import styled from 'styled-components'
import { Title, Subtitle, ContainerFlexColumn } from './Utils/CustomClasses'

const Testimonials = styled(ContainerFlexColumn)`
  background-color: ${({ color }) => (color ? color : '#fff')};
`

const TesTitle = styled(Title)`
  color: ${({ textcolor }) => (textcolor ? textcolor : '#154549')} !importent;
`

const TesSubtitle = styled(Subtitle)`
  color: ${({ textcolor }) => (textcolor ? textcolor : '#154549')} !importent;
`

const FlexRowTestimonial = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  justify-content: flex-end;
  margin-top: 30px;
  width: 100%;

  & > div {
    flex-basis: 50%;
  }

  @media (max-width: 979px) {
    flex-direction: column;
    margin-top: 20px;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const FlexRowTestimonialSingle = styled.div`
  display: flex;
  margin-top: 30px;
  width: 100%;

  flex-direction: column;
  margin-top: 20px;

  & > div {
    width: -webkit-fill-available;
  }
`

const TestimonialsBox = styled.div`
  background-color: #fff;
  border-radius: 26px;
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  padding: 26px 26px 30px;
`

const TesRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;

  & > div {
    flex-basis: 50%;
  }
`

const TesRowSingle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`

const TestimonialPhotoContainer = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border: 3px solid #fff;
  border-radius: 16px;

  img {
    object-fit: cover;
    min-width: 100%;
    min-height: 100%;
  }
`

const TestimonialInfoContainer = styled.div`
  text-align: right;
`

const TesName = styled.p`
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 3px;
`

const TesLoc = styled.p`
  font-size: 16px;
  font-weight: 400;
  margin: 0;
`

const TesText = styled.p`
  font-size: 16px;
  line-height: 29px;
  margin: 20px 0 5px;
`

const TestimonialsPanel = ({
  color,
  textcolor,
  showintro,
  numbertoshow,
  step,
}) => {
  return (
    <Testimonials color={color} center>
      {showintro && (
        <>
          <TesTitle
            color={textcolor}
            size="30px"
            sizemd="1.6rem"
            sizesm="30px"
            center
            margin="0 10vw 24px 10vw"
            marginmd="0 10vw 24px 10vw"
            marginsm="20px 0 24px 0"
            dangerouslySetInnerHTML={{
              __html: `Freebird Club Reviews`,
            }}
          />
          <TesSubtitle
            center
            weight="300"
            color={textcolor}
            size="22px"
            sizemd="22px"
            sizesm="22px"
            margin="0 0 50px 0"
            marginsm="0 8px 40px 8px"
            dangerouslySetInnerHTML={{
              __html: `Our lively and welcoming community is waiting to meet you. See what our members have to say about Freebird Club in their reviews below.`,
            }}
          />
        </>
      )}

      {numbertoshow == 1 && step == 1 && (
        <FlexRowTestimonialSingle>
          <TestimonialsBox>
            <TesRowSingle>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/r9hBXAhcpUzXx5TbkQAZlIp76H60klqt3GKW9msz.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <div>
                <TesName>Mela</TesName>
                <TesLoc>Michigan, USA</TesLoc>
              </div>
            </TesRowSingle>
            <TesText>
              "My husband and I are delighted to find this fabulous resource as
              we are just beginning our worldwide travels. I am excited about
              the opportunities Freebird is organizing here, and all the new
              members joining!"
            </TesText>
          </TestimonialsBox>
        </FlexRowTestimonialSingle>
      )}

      {numbertoshow == 1 && step == 2 && (
        <FlexRowTestimonialSingle>
          <TestimonialsBox>
            <TesRowSingle>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/JBxasixiauege2917t3197etgisvakxvdadvakv.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <div>
                <TesName>Patricia</TesName>
                <TesLoc>Bristol, UK</TesLoc>
              </div>
            </TesRowSingle>
            <TesText>
              "I'm so glad I found this club! The fact that all members are ID
              verified before they can message each other and there is a team
              looking after us makes me feel very safe. That's well worth the
              monthly membership fee."
            </TesText>
          </TestimonialsBox>
        </FlexRowTestimonialSingle>
      )}

      {numbertoshow >= 2 && (
        <FlexRowTestimonial>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/g2t9m6AB3bw2WHMrwkvvJVIyjOJLgYqyJKFcv4Jp.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Isabel Maria</TesName>
                <TesLoc>Piacenza, Italy</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              "I am so happy to have found a community of like-minded people
              with interests in traveling and sharing the experience!"
            </TesText>
          </TestimonialsBox>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/r9hBXAhcpUzXx5TbkQAZlIp76H60klqt3GKW9msz.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Mela</TesName>
                <TesLoc>Michigan, USA</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              "My husband and I are delighted to find this fabulous resource as
              we are just beginning our worldwide travels. I am excited about
              the opportunities Freebird is organizing here, and all the new
              members joining!"
            </TesText>
          </TestimonialsBox>
        </FlexRowTestimonial>
      )}

      {numbertoshow >= 4 && (
        <FlexRowTestimonial>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/eYnh6GqJdfJvAikAK05Usb4XaBCgQHI2rj2fgDx2.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Champika</TesName>
                <TesLoc>Galle, Sri Lanka</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              "I joined this club as I love the idea of connecting with
              like-minded individuals in our 50s and beyond, who are ready to
              enjoy the freedom and adventure that comes with this exciting
              stage of life. Looking forward to meeting you all, and exchanging
              stories, insights, and new adventures! "
            </TesText>
          </TestimonialsBox>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/cJdLJgu2dz0tCfzjErpLkIa8o0ZqfG6elVan6LgK.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Carla</TesName>
                <TesLoc>Calgary, Canada</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              "So pleased to see Freebird Club is getting a new lease on life.
              It's such a great endeavour as it opens doors and provides layers
              and nuances to travel experiences. I eagerly anticipate its
              continued expansion. "
            </TesText>
          </TestimonialsBox>
        </FlexRowTestimonial>
      )}

      {numbertoshow >= 6 && (
        <FlexRowTestimonial>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/bq8iM3QRKXpNbLg9jHTjOfdLPaDu9C9qcY7snMeL.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Antonio</TesName>
                <TesLoc>Estoril, Portugal</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              "So glad I found this exciting and friendly club. I look forward
              to seeing new places and connecting with different people more
              often through Freebird Club."
            </TesText>
          </TestimonialsBox>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/xQzHQivKvTfdD90nGX1sC4yWjxk3JrT0au0cSoNI.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Barbara</TesName>
                <TesLoc>Galway, Ireland</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              "What a fabulous ethos and foundation, delighted to have
              discovered Freebird Club! "
            </TesText>
          </TestimonialsBox>
        </FlexRowTestimonial>
      )}

      {numbertoshow >= 8 && (
        <FlexRowTestimonial>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/M66hf0Y1GqUo5uTYt5pBGy7raeVHa5OFt6Ku85Jf.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Geraldine</TesName>
                <TesLoc>Dublin, Ireland</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              "What I love about the Freebird Club is that you get to meet new
              people and different nationalities. I love hearing about other
              peoples cultures."
            </TesText>
          </TestimonialsBox>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/936FxYE5TubX0gAKUSrUJrc1j2dw8ftpcI0VGeR5.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Anna Maria</TesName>
                <TesLoc>Perugia, Italy</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              ”I found it easy to understand and felt encouraged to travel and
              to host from the website. The fact that you are a similar age is
              good, as you are more likely to get on and share similar
              interests, way of life and needs.“
            </TesText>
          </TestimonialsBox>
        </FlexRowTestimonial>
      )}

      {numbertoshow >= 10 && (
        <FlexRowTestimonial>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/vqZvqj6UzrPL7C6IIrSOYe77CLbf0xSW4C6zQi7o.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Cindy</TesName>
                <TesLoc>Nebraska, USA</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              ”It is people who love to travel and want to interact with
              like-minded people and connect and learn about each others
              cultures while travelling the world.“
            </TesText>
          </TestimonialsBox>
          <TestimonialsBox>
            <TesRow>
              <div>
                <TestimonialPhotoContainer>
                  <img
                    src={
                      'https://fbc-int.s3.eu-west-1.amazonaws.com/gfx/users/large/x0qEZxAfqEkzA0kgsRYdG7GNVRM1QdNB6aewiUBs.jpg'
                    }
                  />
                </TestimonialPhotoContainer>
              </div>
              <TestimonialInfoContainer>
                <TesName>Paul</TesName>
                <TesLoc>Brighton, UK</TesLoc>
              </TestimonialInfoContainer>
            </TesRow>
            <TesText>
              ”What a superb idea for an online community! Having recently
              retired I now have more opportunity than ever to get to know new
              places and cultures and am looking forward to doing so. I would
              love to meet like-minded people with whom to share some travel
              adventures. Freebird Club seems like a great way to do just that.“
            </TesText>
          </TestimonialsBox>
        </FlexRowTestimonial>
      )}
    </Testimonials>
  )
}
export default TestimonialsPanel
